<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">
    <mat-card>
      <mat-card-content>
        <div class="custom-grid">
          <div class="table-responsive-simpli add_factoring custom-mat-table">
            <table mat-table [dataSource]="dataSource" >
              <ng-container matColumnDef="key">
                <td mat-cell *matCellDef="let element" class="key-custom">
                  <input type="text" class="no-input">{{ element.key }}:
                </td>
              </ng-container>
              <ng-container matColumnDef="value">
                <td mat-cell *matCellDef="let element" [ngClass]="{'blur-effect': loading}">
                  <input type="text" class="no-input" readonly>
                  <span *ngIf="loading" class="blur-test-text">Texto prueba Cargando...</span>
                  <span *ngIf="!loading">
                    {{ element.key === 'Días al vencimiento' ? element.value + ' días' : element.value }}
                  </span>
                </td>
              </ng-container>
              
              <tr mat-row *matRowDef="let row; columns: ['key', 'value']"></tr>
            </table>
            
          </div>

          <div class="table-responsive-simpli add_factoring custom-mat-table2">
            <table mat-table [dataSource]="dataSource2">
              <ng-container matColumnDef="key2">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element" [attr.colspan]="element.colspan || 1" class="key-custom">
                  <input type="text" class="no-input" readonly>
                  {{ element.key2 }}:
                </td>
              </ng-container>

              <ng-container matColumnDef="mensual">
                <th mat-header-cell *matHeaderCellDef class="custom-header">Mensual</th>
                <ng-container *matCellDef="let element">
                  <td mat-cell *ngIf="!element.colspan"
                    [ngClass]="{'textGreen': element.key2 === 'Ganancia al vencimiento','blur-effect': loading}">
                    <span *ngIf="loading" class="blur-test-text">0.00%</span>
                    <input *ngIf="!loading" type="text" class="no-input" readonly>
                    {{ element.mensual ? (element.key2 === 'Ganancia al vencimiento' ? ('$' +
                    formatMoney(element.mensual))
                    :
                    (element.key2 === 'Tasa' || element.key2 === 'Spread real' ? (element.mensual + '%') :
                    element.mensual))
                    :
                    '' }}
                  </td>
                </ng-container>
              </ng-container>

              <ng-container matColumnDef="anual">
                <th mat-header-cell *matHeaderCellDef class="custom-header2">Anual</th>
                <td mat-cell *matCellDef="let element"
                  [ngClass]="{'textGreen': element.key2 === 'Ganancia al vencimiento','blur-effect': loading}">
                  <span *ngIf="loading" class="blur-test-text">0.00%</span>
                  <input *ngIf="!loading" type="text" class="no-input" readonly>{{ element.anual ? (element.key2 === 'Ganancia al vencimiento'
                  ? ('$' + formatMoney(element.anual)) : (element.key2 === 'Tasa' || element.key2 === 'Spread real'
                  ?(element.anual + '%') : element.anual)) : '' }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['key2', 'mensual', 'anual']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['key2', 'mensual', 'anual']"></tr>
            </table>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">

    <app-tabla-inversiones />

  </div>
</div>

<div class="row">

  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 col-top">
    <mat-card>
      <app-chart-institucion [title]="'Institución'" />
    </mat-card>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 col-top">
    <mat-card>
      <app-chart-ganancia [title]="'Ganancia al vencimiento'" />
    </mat-card>
  </div>
</div>

<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top mb-20">

    <mat-card>
      <app-chart-proyeccion [title]="'Proyección Ganancia Mensuales*'" />


      <mat-card-actions *ngIf="!isPublicSimulation">
        <button mat-flat-button class="secondary-button" color="primary" (click)="goToPreviousStep()">Anterior</button>
        
        <button mat-flat-button class="primary-button" color="primary" [disabled]="enviandoBtn" (click)="sendPdf()">
          <span *ngIf="!enviandoBtn">Enviar a mi mail</span>
          <span *ngIf="enviandoBtn"><i class="fa-solid fa-spinner fa-spin-pulse"></i></span>
        </button>
      </mat-card-actions>
      
    </mat-card>

  </div>
</div>